<script>
import SectionTitle from '@components/section-title'
import Vue from 'vue'
import store from '@state/store'
import { MODAL, RELOAD } from '@constants/Text'
import { mask } from 'vue-the-mask'
import { light_mode } from '@constants/Color'
import { GlobalBus } from '@services/bus'

export default {
  components: {
    SectionTitle,
  },
  directives: {
    mask,
  },
  props: {
    bus: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      busModal: new Vue(),
      token: '',
      bank: {},
      maskNumber: '#######################',
      gray: light_mode['gray-5'],
      attBanks: false,
    }
  },
  computed: {},
  created() {
    if (this.bus) {
      this.bus.$on(MODAL.TOKEN, (v, attBanks) => {
        this.attBanks = attBanks
        this.busModal.$emit('dialog', v)
        this.token = ''
      })
      this.bus.$on('bank-account', (v) => {
        this.bank = v
      })
    }
    this.busModal.$on('close', this.close)
  },
  methods: {
    sendToken(close) {
      let bank = this.bank
      bank.token = this.token || 'NULL'
      this.bus.$emit('token-bank', bank)
      // if (this.attBanks) {
      //   GlobalBus.$emit(RELOAD.ATT_BANKS)
      // }
      if (close) {
        close()
      } else {
        this.busModal.$emit('dialog', false)
      }
    },
    sendNullToken(close) {
      this.token = ''
      this.sendToken(close)
    },
    closeModal(close) {
      let bank = this.bank
      bank.loading = false
      this.bus.$emit('cancel-token', bank)
      close()
    },
    close() {
      this.bus.$emit('close-modal-token')
    },
  },
}
</script>

<template>
  <BaseModal max-width="60%" heigth="600px" :bus="busModal">
    <div style="padding: 20px">
      <SectionTitle title="Inserir token" :subtitle="bank.nome" />
      <div>
        <p
          :style="{
            'font-size': '12px',
            'margin-top': '20px',
            color: gray,
          }"
        >
          Insira o token do seu banco {{ bank.nome }} e conta {{ bank.conta }}
        </p>
        <v-text-field
          v-model="token"
          v-mask="maskNumber"
          label="Token"
          autofocus
          @keyup.enter="sendToken(false)"
        ></v-text-field>
      </div>
    </div>
    <template v-slot:actions="{ close }">
      <v-spacer />
      <BaseButton underlined @click="closeModal(close)">
        Cancelar
      </BaseButton>
      <BaseButton primary outline @click="sendNullToken(close)">
        Atualizar sem token
      </BaseButton>
      <BaseButton primary @click="sendToken(close)">
        Confirmar
      </BaseButton>
      <v-spacer />
    </template>
  </BaseModal>
</template>


